import Joi from 'joi';
import blockAppearanceSchema from '@utils/validate/blocksSchemes/blockAppearanceSchema';
const categoryLabelBlockSchema = Joi.object({
  type: Joi.string().valid('labelBlock').required(),
  code: Joi.string().allow('', null).required(),
  textColor: Joi.string().allow('', null).required(),
  title: Joi.string().allow('', null).required(),
  variant: Joi.string().allow('', null),
  ...blockAppearanceSchema
}).unknown(true);
export default categoryLabelBlockSchema;